module.exports = __webpack_public_path__ + "googleAuth_38x38.44bc519b04f8694371b372a2b51b7c02.png";